const initState = {
  searchPageQueryParams: '',
  searching: false,
  searchPageKeyWords: '',
  searchPagePriceData: [],
  searchPageSitesLeft: 0
};

export const SEARCH_PAGE_QUERY_PARAMS_UPDATE = 'SEARCH_PAGE_QUERY_PARAMS_UPDATE';
export const updateSearchPageQueryParams = (val) => ({type: SEARCH_PAGE_QUERY_PARAMS_UPDATE, payload: val});

export const SEARCHING_UPDATE = 'SEARCHING_UPDATE';
export const updateSearching = (val) => ({type: SEARCHING_UPDATE, payload: val});
export const SEARCH_PAGE_SEARCHKEYWORDS_UPDATE = 'SEARCH_PAGE_SEARCHKEYWORDS_UPDATE';
export const updateSearchPageSearchKeyWords = (val) => ({type: SEARCH_PAGE_SEARCHKEYWORDS_UPDATE, payload: val});
export const SEARCH_PAGE_PRICEDATA_UPDATE = 'SEARCH_PAGE_PRICEDATA_UPDATE';
export const updateSearchPagePriceData = (val) => ({type: SEARCH_PAGE_PRICEDATA_UPDATE, payload: val});

export const SEARCH_PAGE_START_SEARCH = 'SEARCH_PAGE_START_SEARCH';
export const startSearching = (val) => ({type: SEARCH_PAGE_START_SEARCH, payload: val});
export const SEARCH_PAGE_STOP_SEARCH = 'SEARCH_PAGE_STOP_SEARCH';
export const stopSearching = (val) => ({type: SEARCH_PAGE_STOP_SEARCH, payload: val});

export const SEARCH_PAGE_SITES_LEFT = 'SEARCH_PAGE_SITES_LEFT';
export const updateSearchPageSitesLeft = (val) => ({type: SEARCH_PAGE_SITES_LEFT, payload: val});

export const decrementSearchPageSitesLeft = () => {
  return (dispatch, getState) => {
    let sitesLeft = getState().searchPage.searchPageSitesLeft;
    if (sitesLeft > 0) {
      sitesLeft--;
    }
    dispatch(updateSearchPageSitesLeft(sitesLeft));
  }
}

export default (state = initState, action) => {
  switch (action.type) {
    case SEARCH_PAGE_QUERY_PARAMS_UPDATE:
      return {...state, searchPageQueryParams: action.payload};
    case SEARCHING_UPDATE:
      return {...state, searching: action.payload};
    case SEARCH_PAGE_SEARCHKEYWORDS_UPDATE:
      return {...state, searchPageKeyWords: action.payload};
    case SEARCH_PAGE_PRICEDATA_UPDATE:
      return {...state, searchPagePriceData: action.payload};
    case SEARCH_PAGE_START_SEARCH:
      return {...state, searching: true, searchPagePriceData: [], searchPageSitesLeft: action.payload.numSites, searchPageKeyWords: action.payload.keywords};
    case SEARCH_PAGE_STOP_SEARCH:
      return {...state, searching: false, searchPagePriceData: action.payload, searchPageSitesLeft: 0};
    case SEARCH_PAGE_SITES_LEFT:
      return {...state, searchPageSitesLeft: action.payload};
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/searchPageReducer.js